module.exports = __webpack_public_path__ + "img/confirm_delete.c27d277a.svg";